export default "__VITE_ASSET__D3TYwp6d__"